import { useState } from "react";
import { Box, Button, Skeleton, Typography, CircularProgress } from "@mui/material";
import LayoutComponent from "./LayoutComponent";
import { Download } from "lucide-react";
import MultipleSelectComponent from "../../../shared/MultiSelectComponent";
import { SectionList } from "../../../shared/Helper";
import SelectedTrackersModal from "../../../shared/Dashboard/selectedTrackersModal";
import LayoutDropdown from "../../../shared/Dashboard/layoutDropdown";
import { getCurrentTerms, getProjectTypeFromStorage } from "../../../shared/projectTypeUtils";

const PiersComponent = ({ handleSectionChange, loader, title, data, containerRef, projectList, selectedRow, setSelectedRow, activity, section, handleSelectAll, selectAll, handleClear, setOpenSelectedTrackersModal, openSelectedTrackersModal, activityType, setDownloadD3Loading, downloadD3Loading, currentProject }) => {
  const [showType, setShowType] = useState('pier');
  const TERMS = getCurrentTerms()

  const handleShowTypeChange = (type) => {
    setShowType(type);
  };

  return (
    <Box px={4} py={2} >
      {/* Header Bar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box sx={{ maxWidth: '280px' }}>
          {loader ? (
            <Skeleton variant="rectangular" width={280} height={32} />
          ) : (
            <Typography
              fontSize={22}
              fontWeight={600}
              sx={{
                width: "250px",
                maxWidth: '280px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              Construction Progress
            </Typography>
          )}
        </Box>

        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }} mr={2}>
          <MultipleSelectComponent
            data={SectionList(data?.bulkAllData?.piers)}
            section={section}
            setSection={handleSectionChange}
          />

          <Button variant="contained" color="primary" onClick={() => setOpenSelectedTrackersModal(true)} disabled={selectedRow.length === 0}>{TERMS.VIEW_SELECTED}</Button>

          <Button variant="contained" color="primary" onClick={handleSelectAll}>
            Select All
          </Button>
          <Button variant="contained" color="primary" onClick={handleClear}>
            Clear All
          </Button>
          <LayoutDropdown
            showType={showType}
            onShowTypeChange={handleShowTypeChange}
            projectType={getProjectTypeFromStorage()}
          />
          {currentProject?.type === 0 && <Box sx={{
            backgroundColor: "#f16253",
            color: "white",
            minWidth: 32,
            height: 32,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "5px",
            cursor: "pointer"
          }}
            id="download"
          >
            {downloadD3Loading ? (
              <CircularProgress size={18} sx={{ color: "white" }} />
            ) : <Download size={18} color="white" />}
          </Box>}
        </Box>

      </Box>

      {/* Main Layout */}
      <Box mt={2}>
        <LayoutComponent
          data={data}
          loader={loader}
          containerRef={containerRef}
          projectList={projectList}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          currentSelection={activity}
          showType={showType}
          activityType={activityType}
          setDownloadD3Loading={setDownloadD3Loading}
        />
      </Box>
      <SelectedTrackersModal
        open={openSelectedTrackersModal}
        onClose={() => setOpenSelectedTrackersModal(false)}
        selectedRows={selectedRow}
        trackerTypes={data?.trackerList}
      />
    </Box>
  );
};

export default PiersComponent;
